import React, {
    PropTypes,
} from 'react';
import {connect} from 'react-redux';
import {Panel, Button, Glyphicon, Alert, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import {Dialog} from '../../components';
import {MenuOrder, MenuHeader, MenuSummary, MenuConfirm, OldMenu} from './';
import {QuantityChange, ChangeLocation, ChangeDescription} from './actions';

class MenuView extends React.Component {
    static propTypes = {
        isLoaded: PropTypes.bool.isRequired, // Menu was succesfully loaded
        error: PropTypes.array, // Here is an array of errors if any occurred
        menus: PropTypes.object.isRequired, // Menu items [type][location] => location menu
        saleTimes: PropTypes.array.isRequired, // Sale times [type] => sale time
        QuantityChange: PropTypes.func.isRequired, // Action to change amount of ordered items
        ChangeLocation: PropTypes.func.isRequired, //Action to change saleTime location
        onSave: PropTypes.func.isRequired, // Action to save an order
        onReload: PropTypes.func.isRequired, // Action to save an order
        old: PropTypes.array.isRequired, // Historical data in case if it's available
        date: PropTypes.object.isRequired, // Date of the order
        description: PropTypes.string.isRequired,
        ChangeDescription: PropTypes.func.isRequired,
    };

    state = {
        showOrderConfirmation: false,
        showOrderOk: false,
        after: null
    };


    onChange(type, location, id, count) {
        this.props.QuantityChange(type, location, id, count)
    }

    onChangeLocation(time, location) {
        return this.props.ChangeLocation(time.saleTimeId, time.locations[location].locationId);
    }

    onClearSaleTime(time, location) {
        const {menus, saleTimes} = this.props;
        let menu = JSON.parse(JSON.stringify(menus));
        menu[time][location].wares.forEach((ware, k) => {
            menu[time][location].wares[k].waresQuantity = 0;
        });
        this.saveOrder(menu, saleTimes, 'Вы успешно отменили заказ, сделанный Вами ранее!', 'Заказ изменен!')
    }

    saveOrder(menus, saleTimes, saveTxt, saveTitle) {
        const {onSave, onReload, description} = this.props, t = this;
        onSave(saleTimes, menus, description).then(
            () => t.setState({
                showOrderOk: true,
                orderSaveTxt: saveTxt || 'Ваш заказ успешно сохранен!',
                orderSaveTitle: saveTitle || 'Заказ сохранен!',
                after: onReload
            }),
            error => {
                if (error.data && error.data.returnCode === 0) {
                    t.setState({
                        showOrderOk: true,
                        orderSaveTxt: error.data.error,
                        orderSaveTitle: 'Ошибка!',
                        after: null
                    });
                }
            }
        );
    }

    isWaresFilled(wares) {
        return wares.reduce((res, ware) => res || (ware.waresQuantity > 0 && !ware.isReadOnly), false);
    }

    renderMenu() {
        const {menus, saleTimes, error, old, date, ChangeDescription, description, oldDate} = this.props;
        const onChange = this.onChange, t = this;
        return <div>
            {error.length ? error.map(err => (<Alert bsStyle="danger"><p>{err}</p></Alert>)) : ''}

            {saleTimes.map(function (saleTime) {
                const saleTimeId = saleTime.saleTimeId;
                const location = saleTime.orderLocation;

                if (menus[saleTimeId][location].wares.length > 0) {
                    return <Panel
                        header={
                            <MenuHeader
                                locations={menus[saleTimeId]}
                                saleTime={saleTime}
                                onChangeLocation={t.onChangeLocation.bind(t, saleTime)}/>
                        }
                        footer={
                            <div className="row">
                                <MenuSummary wares={menus[saleTimeId][location].wares}/>
                                {t.isWaresFilled(menus[saleTimeId][location].wares) ?
                                    <div className="col-sm-6"><Button block bsStyle="danger" className="btn-outline"
                                                                      onClick={t.onClearSaleTime.bind(t, saleTimeId, saleTime.orderLocation)}>
                                        Отменить заказ
                                    </Button></div> : ''}
                            </div>
                        }
                    >
                        <MenuOrder
                            onQuantityChange={onChange.bind(t, saleTimeId, location)}
                            menu={menus[saleTimeId][location]}
                        />
                    </Panel>;
                }
                else return '';
            })}

            {(error.length === 0) ?
                <div>
                    <FormGroup controlId="formControlsTextarea">
                        <ControlLabel>Примечания к заказу</ControlLabel>
                        <FormControl componentClass="textarea"
                                     placeholder="Добрый день, ..."
                                     value={description}
                                     inputRef={(ref) => this.description = ref}
                                     onChange={() => ChangeDescription(this.description.value)}
                        />
                    </FormGroup>
                    <Button
                        block
                        bsStyle="success"
                        onClick={() => t.setState({
                            showOrderConfirmation: true
                        })}
                    >Заказать&nbsp;<Glyphicon glyph="shopping-cart"/></Button>
                </div> : ''
            }
            <MenuConfirm
                date={date}
                description={description}
                saleTimes={saleTimes}
                show={t.state.showOrderConfirmation}
                menus={menus}
                yes={
                    () => {
                        t.setState({
                            showOrderConfirmation: false
                        });
                        t.saveOrder(menus, saleTimes);
                    }
                }
                no={() => t.setState({
                    showOrderConfirmation: false
                })}
            />
            <Dialog
                body={t.state.orderSaveTxt||''}
                title={t.state.orderSaveTitle||''}
                show={t.state.showOrderOk}
                yes={() => {
                    if (t.state.after) t.state.after();
                    t.setState({showOrderOk: false, after: null});
                }}
                yesTitle="Закрыть"
                no={() => t.setState({showOrderOk: false})}
            />

            <OldMenu saleTimes={old} date={oldDate}/>
        </div>;
    }

    renderLoading() {
        return (
            <h3>Загрузка...</h3>
        );
    }

    render() {
        const {isLoaded} = this.props;
        return isLoaded ? this.renderMenu() : this.renderLoading();
    }
}

function mapStateToProps(state) {
    const {menus, saleTimes, error, old, date, description, oldDate} = state.food;
    const keys = Object.keys(menus);
    return {
        isLoaded: keys.length !== 0 || error.length > 0,
        menus, saleTimes, error, old, date, description, oldDate
    };
}

export default connect(mapStateToProps, {
    QuantityChange, ChangeLocation, ChangeDescription
})(MenuView);



/** WEBPACK FOOTER **
 ** ./src/modules/food/MenuView.js
 **/